import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { Util } from "@common/utils/util";

export class ViewStateOrder implements IDeepCopy<ViewStateOrder> {
    

    public data: { [id: string]: number } = {};

    public clear() {
        this.data = {};
    }

    public hasValues(): boolean {
        if (Object.keys(this.data).length > 0) return true;
        return false;
    }

    public set(key: string, value: number) {
        this.data[key] = value;
    }

    public get(key: string): number {
        return (this.data[key]) ? this.data[key]:0;
    }

    deepCopy(): ViewStateOrder {
        let ret = new ViewStateOrder();
        ret.data = Util.deepCopy(this.data);
        return ret;
    }
}
